module.exports = __webpack_public_path__ + "img/tick.797f1199.svg";